<template>
  <div class="row">
    <div class="col-12">
      <card>
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="filter">
            <filter-component
              :isRequiredFarms="true"
              @onChangeFilters="handleFilterChange"
              @filter="handleFilter"
              @showHideLoading="showHideLoading"
              classFarms="col-12 col-md-6 col-xl-4"
              ref="filters"
            ></filter-component>
          </el-collapse-item>
        </el-collapse>
      </card>
      <div v-if="isIndex()">
        <card v-if="tableData.length > 0">
          <br />
          <div>
            <div class="row">
              <el-dialog
                :title="$t('sigatoka.sigatoka')"
                class="zoom-map el-dialog-img-zoom"
                top="15px"
                width="80%"
                :visible.sync="modals.map"
                :close="closeMap"
              >
                <multiple-map ref="map" :height="800" />
              </el-dialog>
            </div>
            <card-header
              :propPagination="pagination"
              @searchedQuery="searchedQuery"
            />
            <master-table
              :infoTable="queriedData"
              :columns="tableColumns"
              :showColumnStatus="false"
            >
              <template slot="addColumnsOperations">
                <table-columns-operations
                  v-if="isShow()"
                  @handleView="handleView"
                  :showOperationEdit="false"
                  :canDelete="false"
                  :minWidth="120"
                />
              </template>
            </master-table>
            <card-footer ref="cardfooter" :propPagination="pagination" />
          </div>
          <br />
        </card>
      </div>
      <not-index-permissions v-else />
    </div>
  </div>
</template>
<script>
import Fuse from 'fuse.js';
import i18n from 'src/i18n';
import SweetAlert from 'src/class/Alerts';
import { isset } from 'src/util/Util';
import { Axios } from 'src/class/Axios.js';
import { Pagination as LPagination } from 'src/components/index';
import Filter from 'src/components/Filter/Filters.vue';
import MixinArcgisMap from 'src/util/mixinArcgisMap';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import MultipleMap from 'src/views/Pages/Dashboard/Work/SmartTrack/MultipleMap.vue';
import configTable from 'src/views/Pages/Dashboard/Sigatoka/SigatokaRoute/report-table';

export default {
  components: {
    LPagination,
    [Filter.name]: Filter,
    [MultipleMap.name]: MultipleMap,
  },

  mixins: [MixinMasters, MixinMenu, MixinPermissions, MixinArcgisMap],

  watch: { '$i18n.locale': ['setupTable', 'getSelectAll'] },

  data() {
    return {
      activeName: 'filter',
      center: {
        lat: 10.8906,
        lng: -74.18756,
      },
      dataFilter: {
        farm: [],
        lot: [],
      },
      model: null,
      fuseSearchDetails: null,
      tableColumns: [],
      routes: null,
    };
  },

  computed: {
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
  },

  methods: {
    handleCollapse(val) {
      this.valueCollapse = val;
    },

    handleFilter(data) {
      this.dataFilter = { ...this.dataFilter, ...data };
      this.markingsMobileTracks = false;
      this.getData();
    },

    getData() {
      this.showHideLoading(true);
      const route = 'sigatoka/capture/getheader';
      const data = {
        ...this.dataFilter,
        route: route,
      };
      Axios.postMasters(data)
        .then((res) => {
          this.tableData = res.data.data;
          if (this.tableData.length == 0)
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
          else {
            this.fuseSearch = new Fuse(this.tableData, {
              useExtendedSearch: true,
              threshold: 0.3,
              keys: this.tableColumns.map((prop) => {
                return prop.prop;
              }),
            });
            this.pagination.perPage = 5;
            this.pagination.currentPage = 1;
            this.searchQuery = '';
          }
          this.showHideLoading();
        })
        .catch((err) => {
          this.showHideLoading();
          SweetAlert.warning(err.response.data.message);
        });
    },

    handleView(_, row) {
      this.showHideLoading(true);
      this.rowData = row;
      const data = {
        id: row.id,
        route: 'sigatoka/capture/getroutes',
      };
      Axios.postMasters(data)
        .then((res) => {
          this.routes = res.data.data;
          if (this.routes.length == 0)
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
          else {
            this.openMap();
          }
        })
        .catch((err) => {
          this.showHideLoading();
          SweetAlert.warning(err.response.data.message);
        });
    },

    handleFilterChange() {
      this.tableData = [];
    },

    openMap() {
      this.modals.map = true;
      this.showHideLoading(true);
      this.$nextTick(() => {
        const mapEl = this.$refs.map.$refs.multipleMap;
        this.loadRouteMap(this.routes, mapEl, 'hybrid');
      });
      this.showHideLoading();
    },

    closeMap() {},

    setupTable() {
      const { Table } = configTable();
      this.pagination = { ...Table.pagination };
      this.tableColumns = Table.tableColumns;
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
    }
  },
};
</script>
